import { _createInstance } from '../base';
//实例
let instance = null;
const createSwitch = async function (config) {
    try {
        if (!instance) {
            instance = await _createInstance(`/account/template`, this.$store);
        }
        console.log(instance, config)
        instance.showPanel(config);
    } catch (error) {
    }

}

export default createSwitch;


// WEBPACK FOOTER //
// src/components/dialog/account/index.js